import { BASE_GROUND_OFFSET, PORTAL_RARITY } from "../config";
import { hashSeed } from "./biomes";
import { BLOCK, type VoxelWorld } from "../types";

export function seedHasPortal(seed: number): boolean {
    return hashSeed(seed + 0xba11) % PORTAL_RARITY === 0;
}

export function placeNetherPortal(world: VoxelWorld, heights: number[][], seed: number): void {
    const N = world.size;
    const r1 = hashSeed(seed + 0x9047a1);
    const r2 = hashSeed(seed + 0x9047a2);

    for (let attempt = 0; attempt < 500; attempt++) {
        const x = 3 + ((r1 + attempt * 61) % (N - 10));
        const z = 4 + ((r2 + attempt * 37) % (N - 8));
        const topAbs = BASE_GROUND_OFFSET + heights[x][z];

        const hasSnow = world.get(x, topAbs + 1, z) === BLOCK.SnowBlock;
        let ok = true;
        for (let i = 0; i < 4 && ok; i++) {
            if (BASE_GROUND_OFFSET + heights[x + i][z] !== topAbs) ok = false;
            else {
                const surf = world.get(x + i, topAbs, z);
                const above = world.get(x + i, topAbs + 1, z);
                if (
                    !surf ||
                    surf === BLOCK.Water ||
                    surf === BLOCK.Ice ||
                    surf === BLOCK.Lava
                ) ok = false;
                else if (above && !(hasSnow && above === BLOCK.SnowBlock)) ok = false;
                else if (hasSnow && world.get(x + i, topAbs + 2, z)) ok = false;
            }
        }
        if (!ok) continue;

        const y0 = topAbs + (hasSnow ? 2 : 1);
        for (let i = 0; i < 4; i++) {
            for (let dy = 0; dy < 5; dy++) {
                const isBorder = i === 0 || i === 3 || dy === 0 || dy === 4;
                world.set(x + i, y0 + dy, z, isBorder ? BLOCK.Obsidian : BLOCK.Portal);
            }
        }
        return;
    }
}
